import { z } from "zod";

export const loginFormSchema = z.object({
  email: z.email("Enter a valid email address"),
  password: z.string().min(8, "Password is required or minimum 8 characters"),
});

export type LoginFormValues = z.infer<typeof loginFormSchema>;
